import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { N50A, N60A } from '@atlaskit/theme/colors';
import { dialogWidth, dialogPageTakeoverWidth, grid } from '../style-utils';
import { N30 } from '@atlaskit/theme/colors';
var SIDEBAR_PANE_WIDTH = 272;
var resultContainerVerticalPadding = 8;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var SearchDialogWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tposition: relative;\n\t", "\n\t", "\n\tbox-shadow: ", ";\n\tborder-radius: 3px;\n\tbackground-color: ", ";\n\toverflow: hidden;\n\tmargin-top: ", ";\n\t:focus {\n\t\toutline: none;\n\t}\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 100%;\n\n\t@media screen and (max-width: ", "px) {\n\t\t/* override min-width set by shouldFillContainer being applied on viewports smaller than dialogPageTakeoverWidth */\n\t\tmin-width: 100%;\n\t\tmax-width: 100%;\n\t\tborder-radius: 0;\n\t\tmargin-top: 0;\n\t\tflex: 1;\n\t\toverflow: auto;\n\t}\n"])), function (props) {
  return props.shouldFillContainer ? "width: 100%;" : "width: ".concat(dialogWidth, ";");
}, function (props) {
  return props.isExpanded && props.shouldFillContainer ? "min-width: ".concat(dialogWidth, ";") : '';
}, "var(--ds-shadow-overlay, ".concat('0 ' + grid.multiple(0.5).px + ' ' + grid.px + ' ' + N50A + ', 0 0 1px ' + N60A, ")"), "var(--ds-surface-overlay, #fff)", grid.px, dialogPageTakeoverWidth);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ResultContainerOuter = styled.div({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  maxWidth: '100%',
  boxSizing: 'border-box'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ResultContainer = styled.div({
  overflowX: 'hidden',
  overflowY: 'auto',
  flex: 1,
  maxWidth: '100%',
  boxSizing: 'border-box'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var SidebarScrollContainer = styled.div({
  flex: '1 1 auto',
  overflowX: 'hidden',
  padding: "var(--ds-space-200, 16px)".concat(" ", "var(--ds-space-200, 16px)", " 0 ", "var(--ds-space-200, 16px)")
});

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var SidebarContainerPane = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tflex: 0 1 auto;\n\twidth: ", "px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tmax-height: 100%;\n\tpadding-bottom: ", ";\n\n\t@media screen and (max-width: ", "px) {\n\t\tdisplay: none;\n\t}\n"])), SIDEBAR_PANE_WIDTH, "var(--ds-space-200, 16px)", dialogPageTakeoverWidth);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var SidebarContainerBorder = styled.div({
  margin: "var(--ds-space-200, 16px)".concat(" 0"),
  borderLeft: "var(--ds-border-width, 1px)".concat(" solid ", "var(--ds-border, ".concat(N30, ")"))
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var SidebarBottomFixedContainer = styled.div({
  padding: "var(--ds-space-300, 24px)".concat(" ", "var(--ds-space-200, 16px)", " 0 ", "var(--ds-space-200, 16px)"),
  flex: '0 0 auto'
});
export var SidebarContainer = function SidebarContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SidebarContainerBorder, null), /*#__PURE__*/React.createElement(SidebarContainerPane, null, /*#__PURE__*/React.createElement(SidebarScrollContainer, null, children)));
};
var totalDialogHeightPx = 776 + resultContainerVerticalPadding * 2;
var footerHeight = 48;
var belowDialogSpace = 224;
var aiFullDialogPromptHeight = 64;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var SearchDialogContent = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tmax-height: ", ";\n\tbox-sizing: border-box;\n\tflex: 1;\n\tmin-height: ", ";\n\n\t@media screen and (min-height: ", "px) {\n\t\tmax-height: ", ";\n\t}\n\n\t@media screen and (max-width: ", "px) {\n\t\tmax-height: initial;\n\t\toverflow: auto;\n\t}\n"])), function (props) {
  return "calc(100vh - ".concat(belowDialogSpace - footerHeight + (props.showAtlassianHomeSearchLink ? footerHeight : 0) + (props.aiSearchFullDialogEnabled ? aiFullDialogPromptHeight : 0), "px)");
}, function (props) {
  return props.minHeight ? "".concat(props.minHeight, "px") : 'auto';
}, totalDialogHeightPx + belowDialogSpace, function (props) {
  return "".concat(totalDialogHeightPx - footerHeight - (props.aiSearchFullDialogEnabled ? aiFullDialogPromptHeight : 0), "px;");
}, dialogPageTakeoverWidth);

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ResultRenderWrapper = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tposition: relative;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\tmin-height: ", ";\n\n\t@media screen and (max-width: ", "px) {\n\t\tflex-grow: 1;\n\t}\n"])), function (props) {
  return props.shouldFixMinimumHeight ? "".concat(props.minimumHeight, "px") : 'auto';
}, dialogPageTakeoverWidth);